module.exports = __webpack_public_path__ + "img/gift-sierras.85aea92.png";